import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Container} from "react-bootstrap";

export default function MainWrapper(props) {
    return (
        <Container className="skyduck-app">
            <Row>
                <Col xs={12} sm={12} md={12} lg={3} xl={3} className="main-width-for-mobile">
                    <Container className="sticky-top mt-5 main-top">
                        {props.menu}
                    </Container>
                </Col>
                <Col xs={12} sm={12} md={12} lg={9} xl={9} className="main-width-for-mobile">
                    <Container className="mt-5 main-top">
                        {props.content}
                    </Container>
                </Col>
            </Row>
        </Container>
    );
}